import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as SettingIcon } from '@Assets/setting_icon.svg';
import { PageWrapper, Separator } from '@Components';

interface UnconfiguredPageProps {
  connector?: string;
}

const UnconfiguredPage = ({ connector }: UnconfiguredPageProps) => {
  const { t } = useTranslation();

  return (
    <div className="h-full w-full">
      <PageWrapper
        title={t('ConfigurationPolicy.CPFR.Title')}
        description={
          connector ? (
            <span className="flex items-center gap-2 text-[17px] text-gray-600">
              <SettingIcon stroke="#667085" fill="none" strokeWidth={1.5} className="w-[19px] h-[19px]" />
              {connector}
            </span>
          ) : undefined
        }>
        <Separator orientation="horizontal" className="w-full bg-gray-300 h-[1px]" />
        <div className="flex flex-col items-center justify-center py-20 gap-6">
          <AlertTriangle className="text-error-400" size={48} />
          <div className="text-center max-w-md">
            <h2 className="text-2xl font-semibold text-gray-700 mb-2">
              {t('ConfigurationPolicy.CPFR.UnconfiguredDisclaimerTitle')}
            </h2>
            <p className="text-gray-600">{t('ConfigurationPolicy.CPFR.UnconfiguredDisclaimerMessage')}</p>
          </div>
        </div>
      </PageWrapper>
    </div>
  );
};

export default UnconfiguredPage;
